// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-list[data-v-9fd13028]{\n  margin: 10px;\n  cursor: pointer;\n  transition: 0.4s all ease;\n  text-align: center;\n}\n.dropdown-list[data-v-9fd13028]:hover{\n  text-decoration: none;\n  color: var( --main-color );\n}\n", ""]);
// Exports
module.exports = exports;
